
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.054 4H14h-3.946zM14 19h2V9h-2v10zm-6 0h2V9H8v10zM19 6H5v15.5a.5.5 0 00.5.5h13a.5.5 0 00.5-.5V6zM8.054 0h8v2h-8V0zM16 4h6v2h-1v16a2 2 0 01-2 2H5a2 2 0 01-2-2V6H2V4h14z"}})])
          )
        }
      }
    